import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { storage } from "../Storage";

import { ISessionKeys, IRedirectAfterLoginType } from "@/models";
import { IRoleType } from "@/models/role";
import { IAddPatient, IPatientExistOrNotModule } from "@/models/doctor";

import { config, setRedirectAfterLogin } from "@/store/slices/config";
import { useAppSelector } from "@/store/hooks";
import { setModuleName } from "@/store/slices/doctor/checkMobilePatientExistOrNot";
import { setAddPatient } from "@/store/slices/doctor/topNavigation";
import { setSteps } from "@/store/slices/onboarding/onboarding";
import { IOnboardingSteps } from "@/models/onboarding";

import useIsMobile from "./useIsMobile";
import useIsTablet from "./useIsTablet";

import { clearLocalStorageExcept } from "..";

export const useHealthHubGuestHandler = () => {
  const dispatch = useDispatch();
  const { redirectAfterLogin } = useAppSelector(config);

  const navigate = useNavigate();
  const { isMobile } = useIsMobile();
  const { isTablet } = useIsTablet();

  const roleType = storage.getSessionToken(ISessionKeys.ROLE_TYPE);

  const handleHealthHubGuestAccess = (path: string) => {
    if (roleType === IRoleType.GUEST) {
      dispatch(
        setRedirectAfterLogin({
          ...redirectAfterLogin,
          path,
          navItem: 4,
          type: IRedirectAfterLoginType.HEALTH_HUB,
          isRedirect: true,
        })
      );

      if (!(isMobile || isTablet)) {
        dispatch(setModuleName(IPatientExistOrNotModule.LOGIN));
        dispatch(
          setAddPatient({
            field: IAddPatient.MOBILE_CHECK,
            value: true,
          })
        );
      } else {
        clearLocalStorageExcept(ISessionKeys.LOCATION);
        dispatch(setSteps(IOnboardingSteps.VERIFY_MOBILE_NUMBER));
        navigate("/");
      }

      return false;
    }

    return true;
  };

  return { handleHealthHubGuestAccess };
};
